import { PluralizeLabelPipe } from './pluralize-label.pipe';
import { InterpolateLabelPipe } from './interpolate-label.pipe';

export const Pipes = [
	PluralizeLabelPipe,
	InterpolateLabelPipe,
];
